import { Box, Card, Grid, Typography, useTheme } from '@mui/material'
import MenuItemsABM from '../menu/MenuItemsABM'
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import PercentIcon from '@mui/icons-material/Percent';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import DescriptionIcon from '@mui/icons-material/Description';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const CardItemServicioAdicional = ({item,onEliminar,openModalEdit}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    
    return (
        <Card 
            sx={{
                background: isDarkMode ? '#2d3a52 !important' : '#ffffff !important',
                boxShadow: isDarkMode ? '0 1px 3px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(16, 185, 129, 0.2)' : '0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(16, 185, 129, 0.1)',
                marginTop: 1.5,
                width: {xs: '100%',md:'70%'},
                borderRadius: 2,
                borderLeft: '4px solid #10b981',
                position: 'relative',
                overflow: 'hidden',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
        >
            <Box sx={{ p: 2 }}>
                {/* Header: Badge, Título y Menú */}
                <Box display='flex' alignItems='center' gap={1.5} mb={1.5}>
                    {/* Badge con gradiente */}
                    <Box
                        sx={{
                            px: 1,
                            py: 0.5,
                            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            boxShadow: '0 2px 6px rgba(16, 185, 129, 0.2)'
                        }}
                    >
                        <LocalOfferIcon sx={{ fontSize: 11, color: '#fff' }} />
                        <Typography
                            sx={{
                                color: '#fff',
                                fontSize: 9,
                                fontWeight: 700,
                                textTransform: 'uppercase',
                                letterSpacing: '0.8px'
                            }}
                        >
                            Bonificación
                        </Typography>
                    </Box>

                    {/* Título */}
                    <Typography 
                        sx={{
                            color: isDarkMode ? '#e0e0e0' : '#1f2937',
                            fontWeight: 700,
                            fontSize: {xs: 14, sm: 15},
                            lineHeight: 1.3,
                            flex: 1
                        }}
                    >
                        {item?.nombre_s}
                    </Typography>

                    {/* Menú de acciones */}
                    <MenuItemsABM dataId={item} onEditar={openModalEdit} onEliminar={onEliminar} />
                </Box>

                {/* Contenido principal en Grid compacto */}
                <Box
                    sx={{
                        p: 1,
                        background: isDarkMode ? 'linear-gradient(135deg, #1a3a2e 0%, #1a4d3d 100%)' : 'linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)',
                        borderRadius: '10px',
                        border: isDarkMode ? '1px solid #2a6a50' : '1px solid #d1fae5'
                    }}
                >
                    {/* Primera fila: Descuento y Valor */}
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: {
                                xs: '1fr',
                                sm: 'repeat(2, 1fr)'
                            },
                            gap: 2,
                            mb: 1.5
                        }}
                    >
                        {/* Cantidad */}
                        <Box>
                            <Box display='flex' alignItems='center' gap={0.8} mb={0}>
                                <Box
                                    sx={{
                                        width: 24,
                                        height: 24,
                                        borderRadius: '6px',
                                        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: '0 2px 4px rgba(16, 185, 129, 0.2)'
                                    }}
                                >
                                    <PercentIcon sx={{ fontSize: 13, color: '#fff' }} />
                                </Box>
                                <Typography
                                    sx={{
                                        color: isDarkMode ? '#b0bec5' : '#6b7280',
                                        fontSize: 10,
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}
                                >
                                    Descuento
                                </Typography>
                            </Box>
                            <Typography
                                sx={{
                                    color: isDarkMode ? '#66bb6a' : '#065f46',
                                    fontSize: 15,
                                    fontWeight: 800,
                                    lineHeight: 1,
                                    ml: 4
                                }}
                            >
                                {`${(item?.cantidad_s / 1.0000) * 100}%`}
                            </Typography>
                        </Box>

                        {/* Sub-Total */}
                        <Box>
                            <Box display='flex' alignItems='center' gap={0.8} mb={0}>
                                <Box
                                    sx={{
                                        width: 24,
                                        height: 24,
                                        borderRadius: '6px',
                                        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: '0 2px 4px rgba(16, 185, 129, 0.2)'
                                    }}
                                >
                                    <AttachMoneyIcon sx={{ fontSize: 13, color: '#fff' }} />
                                </Box>
                                <Typography
                                    sx={{
                                        color: isDarkMode ? '#b0bec5' : '#6b7280',
                                        fontSize: 10,
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}
                                >
                                    Valor
                                </Typography>
                            </Box>
                            <Box display='flex' alignItems='baseline' gap={0.4} ml={4}>
                                <Typography
                                    sx={{
                                        color: isDarkMode ? '#66bb6a' : '#065f46',
                                        fontSize: 15,
                                        fontWeight: 800,
                                        lineHeight: 1
                                    }}
                                >
                                    ${((item?.importe_s || 0) * item?.cantidad_s || 1)?.toFixed(2)}
                                </Typography>
                                <Typography
                                    sx={{
                                        color: isDarkMode ? '#b0bec5' : '#6b7280',
                                        fontSize: 10,
                                        fontWeight: 600
                                    }}
                                >
                                    {item?.moneda_s || 'USD'}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Segunda fila: Observaciones (ancho completo) */}
                    <Box
                        sx={{
                            pt: 1.5,
                            borderTop: isDarkMode ? '1px solid #2a6a50' : '1px solid #d1fae5'
                        }}
                    >
                        <Box display='flex' alignItems='center' gap={0.8} mb={0.5}>
                            <Box
                                sx={{
                                    width: 24,
                                    height: 24,
                                    borderRadius: '6px',
                                    background: isDarkMode ? '#3d4a62' : '#e5e7eb',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <DescriptionIcon sx={{ fontSize: 13, color: isDarkMode ? '#b0bec5' : '#6b7280' }} />
                            </Box>
                            <Typography
                                sx={{
                                    color: isDarkMode ? '#b0bec5' : '#6b7280',
                                    fontSize: 10,
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}
                            >
                                Notas
                            </Typography>
                        </Box>
                        <Typography
                            sx={{
                                color: isDarkMode ? '#e0e0e0' : '#374151',
                                fontSize: 11,
                                lineHeight: 1.4,
                                ml: 4,
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}
                        >
                            {item?.obs_s || 'Sin observaciones'}
                        </Typography>
                    </Box>
                </Box>

                {/* Alerta de autorización - minimalista */}
                {(item?.nivelBonificacion === 'bonificacion_nivel2' || item?.nivelBonificacion === 'bonificacion_nivel3') && (
                    <Box
                        sx={{
                            mt: 1.5,
                            px: 1.5,
                            py: 0.8,
                            background: isDarkMode ? 'linear-gradient(135deg, #3d3420 0%, #4a3f2a 100%)' : 'linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)',
                            borderRadius: '8px',
                            border: isDarkMode ? '1px solid #6b5a2e' : '1px solid #fbbf24',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                        }}
                    >
                        <Box
                            sx={{
                                width: 20,
                                height: 20,
                                borderRadius: '50%',
                                background: '#fbbf24',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                                animation: 'pulseWarning 2s ease-in-out infinite',
                                '@keyframes pulseWarning': {
                                    '0%, 100%': { transform: 'scale(1)' },
                                    '50%': { transform: 'scale(1.1)' }
                                }
                            }}
                        >
                            <WarningAmberIcon sx={{ fontSize: 13, color: '#fff' }} />
                        </Box>
                        <Typography
                            sx={{
                                color: isDarkMode ? '#fbbf24' : '#92400e',
                                fontSize: 11,
                                fontWeight: 700,
                                letterSpacing: '0.3px'
                            }}
                        >
                            Requiere autorización de supervisor
                        </Typography>
                    </Box>
                )}
            </Box>
        </Card>
    )
}

export default CardItemServicioAdicional